import React from "react";
import { Card } from "react-bootstrap";
import { AvatarType, importFile } from "./Avatars";
import { capitalize } from "lodash";
import styled from "styled-components";
import artist from '../../assets/images/artist.png'
import genius from '../../assets/images/genius.png'
import queen from '../../assets/images/queen.png'
import professor from '../../assets/images/professor.png'
import poet from '../../assets/images/poet.png'

export type NFTProps = {
  setSelectedAvatar: any;
  id: string;
};

const title = (id: string) => `The ${capitalize(id)}`;

const images = {
  [AvatarType.Artist]: artist,
  [AvatarType.Genius]: genius,
  [AvatarType.Queen]: queen,
  [AvatarType.Professor]: professor,
  [AvatarType.Poet]: poet,
  [AvatarType.Custom]: "",
};

const texts = {
  [AvatarType.Artist]:
    "A vibrant force of passion, color, and truth. The Artist leads with emotion and never shies away from saying what needs to be said. She believes every vote is a brushstroke on the canvas of culture. With her creative fire and unapologetic voice, she turns opinions into art and rallies the community to express themselves boldly.",
  [AvatarType.Genius]:
    "If logic had a heartbeat, it would sound like him. The Genius brings structure to the chaos, dropping truth bombs and calculations in equal measure. He loves the sound of facts and the thrill of winning with reason. When he votes, it’s not a guess — it’s a formula for impact. ",
  [AvatarType.Queen]:
    "Commanding yet graceful, The Queen speaks softly but moves mountains. Her strategy is silent power. Her votes are royal decrees. She’s the one who reminds the Parliament that elegance and influence are not mutually exclusive — they’re her superpower.",
  [AvatarType.Professor]:
    "Curious, eccentric, and brilliant — The Professor thrives on turning questions into revolutions. With wild hair and wilder ideas, he breaks down complex truths so anyone can understand. He’s the people’s brain, constantly reminding the Parliament that knowledge is the ultimate vote multiplier.",
  [AvatarType.Poet]:
    "Where others see polls, he sees poetry. The Poet believes every vote has a soul, and every opinion is a verse. With charm, wit, and a flair for drama, he turns even the most casual debates into performances that leave the crowd wanting more.",
  [AvatarType.Custom]:"",
};

const knownFor = {
  [AvatarType.Artist]: "The Rebel Heart",
  [AvatarType.Genius]: "The Formula",
  [AvatarType.Queen]: "The Crown Call",
  [AvatarType.Professor]: "The Brainwave",
  [AvatarType.Poet]: "The Wordsmith",
  [AvatarType.Custom]: "",
};
const occupation = {
  [AvatarType.Artist]: "Visionary, Cultural Creator",
  [AvatarType.Genius]: "Thinker, Mathematician of Democracy",
  [AvatarType.Queen]: "Diplomat, Powerhouse",
  [AvatarType.Professor]: "Teacher of Truths",
  [AvatarType.Poet]: "Storyteller, Crowd Charmer",
  [AvatarType.Custom]: "",
};
const hobbies = {
  [AvatarType.Artist]: "Painting, Protesting, Spicy Debates",
  [AvatarType.Genius]: "Solving, Tinkering, Classical Music",
  [AvatarType.Queen]: "Jewelry, Legacy, Secret Alliances",
  [AvatarType.Professor]: "Chalk Dust, Quantum Theories, Voting Systems",
  [AvatarType.Poet]: "Late-Night Rants, Smooth Speeches",
  [AvatarType.Custom]: "",
};

const Container = styled(Card)`
  width: 100%;
  height: auto;
  padding: 5px 5px 38px 5px;
  border-radius: 6px;
  border: #fff solid 6px;
  background: rgb(55, 18, 179);
  background: -webkit-linear-gradient(
    rgba(93, 70, 224, 1) 0%,
    rgba(55, 18, 179, 1) 77%,
    rgba(19, 3, 49, 1) 100%
  );
  background: -o-linear-gradient(
    rgba(93, 70, 224, 1) 0%,
    rgba(55, 18, 179, 1) 77%,
    rgba(19, 3, 49, 1) 100%
  );
  background: linear-gradient(
    rgba(93, 70, 224, 1) 0%,
    rgba(55, 18, 179, 1) 77%,
    rgba(19, 3, 49, 1) 100%
  );
  position: relative;
`;

const Title = styled.div`
  font-size: 24px;
  color: #fff;
  text-transform: uppercase;
  text-align: left;
  font-weight:600;
  margin-top:10px;
  margin-bottom:10px;
`;

const Video = styled.video`
  width: 100%;
  max-width: 300px;
  height: 300px;
  margin: 0 auto;
  border-radius: 20px;
`;

const ImageDiv = styled.div`
  width: 100%;
  max-width: 300px;
  height: 300px;
  margin: 0 auto;
  border-radius: 20px;
`;

const Body = styled(Card.Body)`
flex-direction:column;
  font-size: 14px;
  line-height: 18px;
  color: #fff;
  // margin: 0 20px;
  padding-top:0;
`;

const Footer = styled.div`
  color: var(--color-160133);
  text-align: left;
  letter-spacing: 0;
  text-transform: uppercase;
  opacity: 1;
  background: white;
  border-radius: 0 38px 0 0px;
  width: 164px;
  padding: 8px;
  padding-bottom:0px;
  font: normal normal normal 13px/20px Poppins;
  font-size: 13px;
  position: absolute;
  bottom: 0;
  left: 0;
`;
const CloseButton = styled.span`
  width: 10px;
  align-self:end;
  margin-right:10px;
  font-size:22px;
  font-weight:400;
cursor:pointer;
position:absolute;
`;
const Paragraph = styled.p`
font-weight:300;`
const NFT = ({ setSelectedAvatar, id }: NFTProps) => {
  return (
    <Container style={{ marginTop: '15px', maxWidth: '350px' }}>

      <CloseButton aria-hidden="true" onClick={() => setSelectedAvatar('')}>&times;</CloseButton>

      <Body>
        <Title>{title(id)}</Title>
        {/* <Video width="300" height="300" autoPlay={true} loop={true} playsInline>
          <source
            src={`${importFile(`./videos/${images[id as AvatarType]}`, "mp4")
              .default || ""
              }`}
            type="video/mp4"
          />
        </Video> */}
        <ImageDiv >
          <img src={images[id as AvatarType]} alt="" width={"200px"}/>
        </ImageDiv>
        <Paragraph className="mb-2">{texts[id as AvatarType]}</Paragraph>
        <div>
          <Paragraph>Known for - {knownFor[id as AvatarType]}</Paragraph>
          <Paragraph>Occupation - {occupation[id as AvatarType]}</Paragraph>
          <Paragraph>Hobbies - {hobbies[id as AvatarType]}</Paragraph>
        </div>
      </Body>
      <Footer><span style={{ fontWeight: 900 }}>NFT</span> - COLLECTABLE</Footer>
    </Container>
  );
};

export default NFT;
